import {
  AddCircleOutlineOutlined,
  ArrowCircleLeftOutlined,
  ArrowCircleRightOutlined,
  CloseFullscreenTwoTone,
  Delete,
  Edit,
  LibraryAdd,
  NewspaperRounded,
  PauseCircle,
  Preview,
  Refresh,
} from '@mui/icons-material'
import { Icon } from '@iconify/react'
import AdsClickIcon from '@mui/icons-material/AdsClick'
import PreviewIcon from '@mui/icons-material/Preview'
import PrintIcon from '@mui/icons-material/Print'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import ReplyAllIcon from '@mui/icons-material/ReplyAll'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import PaymentIcon from '@mui/icons-material/Payment'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn'
import ClearAllIcon from '@mui/icons-material/ClearAll'
import BeenhereIcon from '@mui/icons-material/Beenhere'
import MoveDownIcon from '@mui/icons-material/MoveDown'
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated'
import PublishIcon from '@mui/icons-material/Publish'
import DataSaverOnIcon from '@mui/icons-material/DataSaverOn'
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useTranslation } from 'react-i18next'


export const useButtonConfig = () => {
  const { t } = useTranslation('buttonList'); // 'buttonList' namespace'ini kullanarak çeviri fonksiyonunu alıyoruz


  const buttonConfig = {
    backSup: {
      id: `backSup`,
      onClick: 'handleBackSup',
      icon: <ArrowCircleLeftOutlined sx={{ color: 'black' }} />,
      text: t('back'),
    },
    nextSup: {
      id: `nextSup`,
      onClick: 'handleNextSup',
      icon: <ArrowCircleRightOutlined sx={{ color: 'black' }} />,
      text: t('next'),
    },
    save: {
      id: `save`,
      onClick: 'handleSave',
      icon: <Icon icon="fa:save" color="black" width="14" height="14" />,
      text: t('save'),
    },
    saveAndClose: {
      id: `saveAndClose`,
      onClick: 'handleSaveAndClose',
      icon: <CloseFullscreenTwoTone sx={{ color: 'black' }} />,
      text: 'Save and Close',
    },
    saveAndNew: {
      id: `saveAndNew`,
      onClick: 'handleSaveAndNew',
      icon: <NewspaperRounded sx={{ color: 'black' }} />,
      text: 'Save and New',
    },
    confirm: {
      id: `confirm`,
      onClick: 'handleConfirm',
      icon: <Icon icon="icon-park-solid:check-one" color="#68bb41" width="16" height="16" />,
      text: 'Accept',
    },
    approve: {
      id: `approve`,
      onClick: 'handleApprove',
      icon: <Icon icon="icon-park-solid:check-one" color="#68bb41" width="16" height="16" />,
      text: 'Approve',
    },
    hold: {
      id: `hold`,
      onClick: 'handleHold',
      icon: <PauseCircle sx={{ color: '#ffeb3b' }} />,
      text: 'Hold',
    },
    reject: {
      id: `reject`,
      onClick: 'handleReject',
      icon: <Icon icon="ic:sharp-cancel" color="red" />,
      text: 'Reject',
    },

    refresh: {
      id: `refresh`,
      onClick: 'handleRefresh',
      icon: <Refresh sx={{ color: 'black' }} />,
      text: 'Refresh',
    },
    create: {
      id: `create`,
      onClick: 'handleCreate',
      icon: <AddCircleOutlineOutlined sx={{ color: '#1976d2' }} />,
      text: 'asdsadsadsad',
    },
    createRequest: {
      id: `createRequest`,
      onClick: 'handleCreateRequest',
      icon: <AddCircleOutlineOutlined sx={{ color: '#1976d2' }} />,
      text: 'sadsadadwdwadaw',
    },
    edit: {
      id: `edit`,
      onClick: 'handleEdit',
      icon: <Edit sx={{ color: 'orange' }} />,
      text: 'Edit',
    },
    delete: {
      id: `delete`,
      onClick: 'handleDelete',
      icon: <Delete sx={{ color: 'red' }} />,
      text: 'Delete',
    },
    attachment: {
      id: `attachment`,
      onClick: 'handleUploadDialog',
      icon: (
        <div
          style={{
            background: '#1565c0',
            padding: '4px',
            borderRadius: '50%',
            display: 'flex',
          }}
        >
          <Icon icon="iconoir:attachment" color="#fff" />
        </div>
      ),
      text: 'Attachment',
    },
    import: {
      id: `import`,
      onClick: 'handleImport',
      icon: <Icon icon="solar:import-bold-duotone" color="green" width="30" height="30" />,
      text: 'Import',
    },
    next: {
      id: `next`,
      onClick: 'handleNext',
      icon: <ArrowCircleRightOutlined sx={{ color: 'black' }} />,
      text: 'Next',
    },

    submit: {
      id: `submit`,
      onClick: 'handleSubmit',
      icon: <Icon icon="lucide:calendar-check" color="black" />,
      text: t('submit'),
    },
    report: {
      id: `report`,
      onClick: 'handleReport',
      icon: <Icon icon="fluent-mdl2:report-document" color="black" />,
      text: 'Report',
    },
    devMode: {
      id: `devMode`,
      onClick: 'handleDevMode',
      icon: <Icon icon="icon-park:source-code" />,
      text: 'Dev Mode',
    },
    log: {
      id: `log`,
      onClick: 'handleLog',
      icon: <Preview sx={{ color: 'black' }} />,
      text: 'Log',
    },
    sendToApprovals: {
      id: `sendToApprovals`,
      onClick: 'handleSendToApprovals',
      icon: <Icon icon="fa:send" />,
      text: 'Send to Approvals',
    },

    checkVendors: {
      id: `checkVendors`,
      onClick: 'handleCheckVendors',
      icon: <Icon icon="fa:send" />,
      text: 'Check vendors',
    },
    addItem: {
      id: `addItem`,
      onClick: 'handleAddItem',
      icon: <LibraryAdd />,
      text: 'Add Item',
    },
    select: {
      id: `select`,
      onClick: 'handleSelect',
      icon: <AdsClickIcon />,
      text: 'Select',
    },
    show: {
      id: `show`,
      onClick: 'handleShow',
      icon: <PreviewIcon />,
      text: 'Show',
    },
    print: {
      id: `print`,
      onClick: 'handlePrint',
      icon: <PrintIcon />,
      text: 'Print',
    },

    createPO: {
      id: `createPO`,
      onClick: 'handleCreatePO',
      icon: <Icon icon="fa:send" />,
      text: 'Create PO',
    },
    createDocument: {
      id: `createDocument`,
      onClick: 'handleCreateDocument',
      icon: <NoteAddIcon />,
      text: 'Create Document',
    },
    retrieve: {
      id: `retrieve`,
      onClick: 'handleRetrieve',
      icon: <ReplyAllIcon />,
      text: 'Retrieve',
    },
    returnToApproved: {
      id: `returnToApproved`,
      onClick: 'handleReturnToApproved',
      icon: <KeyboardReturnIcon />,
      text: 'Return To Approved',
    },
    sendtoBank: {
      id: `sendtoBank`,
      onClick: 'handleSendtoBank',
      icon: <AccountBalanceIcon />,
      text: 'Send to Bank',
    },
    pay: {
      id: `pay`,
      onClick: 'handlePay',
      icon: <PaymentIcon />,
      text: 'Pay',
    },
    changeBank: {
      id: `changeBank`,
      onClick: 'handleChangeBank',
      icon: <ClearAllIcon />,
      text: 'Changes Payment Bank Charge',
    },
    copyRequest: {
      id: `copyRequest`,
      onClick: 'handleCopyRequest',
      icon: <ClearAllIcon />,
      text: 'Copy Request',
    },
    postToS: {
      id: `postToS`,
      onClick: 'handlepostToS',
      icon: <BeenhereIcon />,
      text: 'Post to SS',
    },
    matchInvoice: {
      id: `matchInvoice`,
      onClick: 'handleMatchInvoice',
      icon: <Icon icon="fa-solid:receipt" color="#699BF7" width="20" height="20" />,
      text: 'Match',
    },

    action: {
      id: `action`,
      onClick: 'handleViewDetails',
      icon: <PlayArrowIcon style={{ fontSize: 25 }} />,
      text: 'View Details',
    },
    submitAndCreate: {
      id: `submitAndCreate`,
      onClick: 'handleSubmitAndCreate',
      icon: <BeenhereIcon />,
      text: 'Submit and create Liabilities',
    },
    transferToSunsystems: {
      id: `transferToSunsystems`,
      onClick: 'handleTransferToSunsystems',
      icon: <MoveDownIcon />,
      text: 'Transfer to Sunsystems',
    },
    excelTemplateDownload: {
      id: `excelTemplateDownload`,
      onClick: 'handleExcelTemplateDownload',
      icon: <BrowserUpdatedIcon />,
      text: 'Excel Template Download',
    },
    importExcelFile: {
      id: `importExcelFile`,
      onClick: 'handleImportExcelFile',
      icon: <PublishIcon />,
      text: 'Excel Import',
    },
    createOrderWithoutPO: {
      id: `createOrderWithoutPO`,
      onClick: 'handleCreateOrderWithoutPO',
      icon: <DataSaverOnIcon />,
      text: 'Create Order',
    },
  }

  return buttonConfig
}
